export const opcoes_agrupamento_incidencia = [
  { value: null, label: 'Independente' },
  { value: 'uteis_sab', label: 'Úteis + Sábado' },
  { value: 'uteis_sab_dom', label: 'Úteis + Sábado + Domingo' },
  { value: 'uteis_sab_dom_fer_folga', label: 'Úteis + Sábado + Domingo + Feriado + Folga' },
  { value: 'sab_dom', label: 'Sábado + Domingo' },
  { value: 'sab_dom_fer', label: 'Sábado + Domingo + Feriado' },
  { value: 'dom_fer', label: 'Domingo + Feriado' },
  { value: 'uteis_sab_e_dom_fer', label: '(Úteis + Sábado) e (Domingo + Feriado)' },
  { value: 'uteis_dom_e_sab_fer', label: '(Úteis + Domingo) e (Sábado + Feriado)' },
];

export const clusters_agrupamento_incidencia = {
  uteis_sab: { uteis_sab: ['uteis', 'sabado'] },
  uteis_sab_dom: { uteis_sab_dom: ['uteis', 'sabado', 'domingo'] },
  uteis_sab_dom_fer_folga: { uteis_sab_dom_fer_folga: ['uteis', 'sabado', 'domingo', 'feriado', 'folga'] },
  sab_dom: { sab_dom: ['sabado', 'domingo'] },
  sab_dom_fer: { sab_dom_fer: ['sabado', 'domingo', 'feriado'] },
  dom_fer: { dom_fer: ['domingo', 'feriado'] },
  uteis_sab_e_dom_fer: { uteis_sab: ['uteis', 'sabado'], dom_fer: ['domingo', 'feriado'] },
  uteis_dom_e_sab_fer: { uteis_dom: ['uteis', 'domingo'], sab_fer: ['sabado', 'feriado'] },
};

export const nomes_incidencia = {
  uteis: 'Úteis',
  sabado: 'Sábado',
  domingo: 'Domingo',
  feriado: 'Feriado',
  folga: 'Folga',
  dia_especial: 'Dia especial',
};

export function resolverAgrupamento(agrupar_incidencias) {
  const grupos = clusters_agrupamento_incidencia[agrupar_incidencias] || {};
  const hidden = new Set();
  const chavePorIncidencia = {};
  const labelPorIncidencia = {};

  Object.entries(grupos).forEach(([chave, incidencias]) => {
    const [representante, ...resto] = incidencias;
    chavePorIncidencia[representante] = chave;
    labelPorIncidencia[representante] = nomes_incidencia[representante];
    resto.forEach(inc => hidden.add(inc));
  });

  return { hidden, chavePorIncidencia, labelPorIncidencia };
}

const REPRESENTANTE_POR_CHAVE = Object.values(clusters_agrupamento_incidencia)
  .reduce((acc, grupos) => {
    Object.entries(grupos).forEach(([chave, incidencias]) => {
      acc[chave] = incidencias[0];
    });
    return acc;
  }, {});


export function resolverIncidenciaParaAba(agrupar_incidencias, incidenciaOuChave) {
  const grupos = clusters_agrupamento_incidencia[agrupar_incidencias] || {};

  for (const [chave, incidencias] of Object.entries(grupos)) {
    if (chave === incidenciaOuChave) {
      return incidencias[0];
    }
  }

  if (REPRESENTANTE_POR_CHAVE[incidenciaOuChave]) {
    return REPRESENTANTE_POR_CHAVE[incidenciaOuChave];
  }

  return incidenciaOuChave;
}

export const ORDEM_INCIDENCIAS = ['uteis', 'sabado', 'domingo', 'feriado', 'folga', 'dia_especial'];
